
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { TAccount } from "@/models/account";
import { CFormField, validateFormFields } from "@/models/form_cards";
import { API_ROUTES } from "@/utils/API";
import { SMToaster } from "@/store";
import { SUCCESS_NOTIFICATION_TYPE } from "@/constants/notification";

@Component({
  components: {
    PasswordRequirements: () =>
      import("@/components/PasswordRequirements/PasswordRequirements.vue"),
  },
})
export default class ChangePasswordPopup extends Vue {
  @Prop({ type: Boolean, default: false }) readonly show!: boolean;
  @Prop({ type: Object, required: true }) readonly account!: TAccount;

  showPopup = false;

  loading = false;

  @Watch("show", { immediate: true })
  showPopupChanged(val: boolean) {
    this.showPopup = val;
  }

  open() {
    this.showPopup = true;
  }

  close() {
    this.showPopup = false;

    this.$emit("close");
  }

  password1 = new CFormField("Password").addRuleByAlias("password");

  password2 = new CFormField("Confirm password").addRule(
    () => this.doPasswordsMatch || "Password doesn't match"
  );

  get doPasswordsMatch() {
    return this.password1.value === this.password2.value;
  }

  get fields() {
    const { password1, password2 } = this;

    const payload = [password1, password2];

    return payload;
  }

  get isFormValid() {
    const { fields } = this;

    const isEachFieldValid = validateFormFields(fields);

    return !!isEachFieldValid;
  }

  async confirmPassword() {
    const { password1, password2 } = this;

    const data = {
      password_1: password1.value,
      password_2: password2.value,
    };

    try {
      this.loading = true;

      await this.axios.post(API_ROUTES.MY_ACCOUNT_PASSWORD, data);

      this.$root.$emit("show-notification", {
        type: SUCCESS_NOTIFICATION_TYPE,
        title: this.$tc("notification.passwordChanged"),
      });
    } catch (e) {
      SMToaster.emitError(e);
    } finally {
      this.loading = false;

      this.close();
    }
  }
}
